import AccountSettings from "../components/AccountSettings";
import Layout from "../components/Layout";
import { Container } from "@mui/material";

export default function AccountSettingsPage() {
  return (
    <Layout title="Account Settings" content="Account Settings Page">
      <Container component="main" maxWidth="md">
        <AccountSettings />
      </Container>
    </Layout>
  );
}
